<template>
    <!-- 地图组件 -->
    <div id="echart" class="echart"></div>
</template>
<script>
import * as echarts from 'echarts' //引入echarts
import changduMap from '@/assets/json/changdu.json'
import { ref, nextTick } from 'vue'
export default {
    name: 'HomeHead',
    props: {},
    setup(props, { emit }) {
        const onMounted = (() => {
            nextTick(() => {
                echarts.registerMap('changdu', { geoJSON: changduMap })
                // 基于准备好的dom，初始化echarts实例
                const myChart = echarts.init(document.getElementById('echart'));
                // 绘制图表
                myChart.setOption({
                    title: {
                        text: '',
                        subtext: '',
                    },
                    // tooltip: {
                    //   trigger: 'item',
                    //   // formatter: '{b}<br/>{c} (p / km2)'
                    // },
                    geo: {
                        map: "changdu",
                        aspectScale: 0.75, //长宽比
                        zoom: 1.1,
                        roam: false,
                        itemStyle: {
                            normal: {
                                areaColor: "#000",
                                shadowColor: "#000",
                                shadowOffsetX: 0,
                                shadowOffsetY: 10
                            },
                            emphasis: {
                                label: {
                                    show: false
                                }
                            }
                        }
                    },
                    geo: [{
                        map: "changdu",
                        aspectScale: 0.75, //长宽比
                        zoom: 1.1,
                        roam: false,
                        itemStyle: {
                            normal: {
                                areaColor: "#cef2fd",
                                shadowColor: "#cef2fd",
                                shadowOffsetX: 10,
                                shadowOffsetY: 15
                            },
                            emphasis: {
                                label: {
                                    show: false
                                }
                            }
                        }
                    }, {
                        map: "changdu",
                        aspectScale: 0.75, //长宽比
                        zoom: 1.1,
                        roam: false,
                        itemStyle: {
                            normal: {
                                areaColor: "#0abdf4",
                                shadowColor: "#0abdf4",
                                shadowOffsetX: 5,
                                shadowOffsetY: 10
                            },
                            emphasis: {
                                label: {
                                    show: false
                                }
                            }
                        }
                    }],
                    series: [
                        {
                            name: '',
                            type: 'map',
                            mapType: 'changdu', // 自定义扩展图表类型
                            label: {
                                show: true,
                                color: '#fff'
                            },
                            zoom: 1.1,
                            geoIndex: 2,
                            aspectScale: 0.75, //长宽比
                            roam: false,
                            itemStyle: {
                                normal: {
                                    borderColor: '#fff',
                                    borderWidth: 2,
                                    areaColor: {
                                        type: 'linear-gradient',
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 350,
                                        colorStops: [{
                                            offset: 0.5,
                                            color: '#0aebf4' // 0% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#0abdf4' // 100% 处的颜色
                                        }],
                                        global: true // 缺省为 false
                                    },
                                },
                            },
                            select: {
                                itemStyle: {
                                    areaColor: '#f93434',
                                    borderColor: '#fff'
                                },
                                label: {
                                    show: true,
                                    color: '#fff'
                                },
                            },
                            emphasis: {
                                itemStyle: {
                                    areaColor: '#f93434',
                                    borderColor: '#fff'
                                },
                                label: {
                                    show: true,
                                    color: '#fff'
                                },
                            },
                            data: [
                                { name: '卡若区', district: '540302' },
                                { name: '江达县', district: '540321' },
                                { name: '贡觉县', district: '540322' },
                                { name: '类乌齐县', district: '540323' },
                                { name: '丁青县', district: '540324' },
                                { name: '察雅县', district: '540325' },
                                { name: '八宿县', district: '540326' },
                                { name: '左贡县', district: '540327' },
                                { name: '芒康县', district: '540328' },
                                { name: '洛隆县', district: '540329' },
                                { name: '边坝县', district: '540330' },
                            ],
                            // 自定义名称映射
                            // nameMap: {
                            //   'Central and Western': '中西区',
                            // }
                        }
                    ]
                });
                myChart.on("click", function (params) {
                    //点击事件
                    emit('onMapClick', params)
                });
            })
        })
        onMounted()
        return {
            onMounted
        }
    }
}
</script>
<style scoped lang="less">
.echart {
    width: 100%;
    height: 100%;
}
</style>
  